import { get } from "app/utils/axios/kheti";
import { ProductCatalogListing } from "app/models/RequestFlow";
import ApiResponse from "app/models/apiResponse";

const fetchRequestProducts = async (
	page: number,
	vendor_id?: number,
	category_id?: string,
	brand_id?: string,
	search_query?:string,
	role_type?:string,
) => {
	try {
		const params: Record<string, string> = {
			page: page.toString(),
			page_size: "10",
		};
		if(role_type) params.role_type = role_type;
		if (vendor_id) params.vendor_id = vendor_id.toString();
		if (category_id) params.category_id = category_id;
		if (brand_id) params.brand_id = brand_id;
 	if (search_query) params.name = search_query;
		const response = await get<ApiResponse<ProductCatalogListing>>(
			`approvals/v1/catalog`,
			params
		);
		return response;
	} catch (e) {
		console.log("Error fetching price change requests:", e)
		return e;
	}
};

export default fetchRequestProducts;